export default __webpack_public_path__ + "static/media/flag-lv.15bb6101.svg";